import type { IStorage } from '../types/common';

/**
 * Implements IStorage using the browser's localStorage object.
 */
class LocalStorage implements IStorage {
  storage: any;

  constructor() {
    if (typeof localStorage === 'undefined') {
      throw new Error('LocalStorage is not available');
    }
    this.storage = localStorage;
  }

  getItem(key: string): Promise<string> {
    const value = this.storage.getItem(key);
    return Promise.resolve(value);
  }

  setItem(key: string, value: string): Promise<void> {
    this.storage.setItem(key, value);
    return Promise.resolve();
  }

  removeItem(key: string): Promise<void> {
    this.storage.removeItem(key);
    return Promise.resolve();
  }

  clear(): Promise<void> {
    this.storage.clear();
    return Promise.resolve();
  }
}

export { LocalStorage };
